import {request} from "../request/request";

const bell = {
  all: () => request.read('/bell'),
};

export {bell};